import { render, staticRenderFns } from "./activityTable.vue?vue&type=template&id=dfbe44e0&scoped=true"
import script from "./activityTable.vue?vue&type=script&lang=js"
export * from "./activityTable.vue?vue&type=script&lang=js"
import style0 from "./activityTable.vue?vue&type=style&index=0&id=dfbe44e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbe44e0",
  null
  
)

export default component.exports